import {useEffect, useId, useRef, useState} from 'react';
import cn from 'classnames';

import {HeaderButtonCommonProps} from '@/shared/components/Header';
import {TIARA_DETAIL_ACTION} from '@/shared/constants/tiara';

export type ComboBoxButtonProps = HeaderButtonCommonProps & {
  options: {
    label: string;
    onClick: () => void;
  }[];
  onExpanded?: () => void;
};

const ComboBoxButton = ({trackEvent, options, onExpanded}: ComboBoxButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const areaRef = useRef<HTMLDivElement>(null);
  const buttonId = useId();
  const listId = useId();

  const onClickComboBox = () => {
    trackEvent({action: TIARA_DETAIL_ACTION.GROUP_ACTION_BUTTON_CLICK});
    setIsOpen((prev) => !prev);
  };

  const onClickOption = (option: ComboBoxButtonProps['options'][number]) => {
    setIsOpen(false);
    option.onClick();
  };

  useEffect(() => {
    const handleClickOutside = (event: PointerEvent) => {
      if (areaRef.current && !areaRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.body.addEventListener('pointerdown', handleClickOutside);
      onExpanded?.();
    }

    return () => {
      document.body.removeEventListener('pointerdown', handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className={cn('item_util', {open: isOpen})} ref={areaRef}>
      <button
        type="button"
        className="btn_util"
        id={buttonId}
        aria-controls={listId}
        aria-haspopup="listbox"
        role="combobox"
        aria-expanded={isOpen}
        tabIndex={0}
        onClick={onClickComboBox}
      >
        <span className="icon icon_menu">관리</span>
      </button>
      <ul id={listId} className="list_select" role="listbox" aria-label="카드 관리 메뉴" tabIndex={-1}>
        {options.map((option) => (
          <li role="option" key={option.label}>
            <button type="button" className="btn_opt" onClick={() => onClickOption(option)}>
              <span className="txt_opt">{option.label}</span>
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default ComboBoxButton;
